(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-display-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function oloePad(n) {
      n = Math.max(0, n);
      return String(n).length < 2 ? '0' + n : String(n);
    }

    function oloeStartCountdown(el) {
      var endRaw = el.getAttribute('data-end');
      if (!endRaw) return;

      // Supports "YYYY-MM-DDTHH:MM" (treated as visitor local time)
      var endDate = new Date(endRaw);
      if (isNaN(endDate.getTime())) return;

      var hideOnExpire = el.getAttribute('data-hide-on-expire') === 'true';
      var expiredText = el.getAttribute('data-expired-text') || 'Sale has ended';
      var timerId = null;

      var dayEls = el.querySelectorAll('[data-unit="days"]');
      var hourEls = el.querySelectorAll('[data-unit="hours"]');
      var minEls = el.querySelectorAll('[data-unit="minutes"]');
      var secEls = el.querySelectorAll('[data-unit="seconds"]');

      function setUnit(nodeList, value) {
        nodeList.forEach(function (node) {
          node.textContent = oloePad(value);
        });
      }

      function tick() {
        var diff = endDate.getTime() - Date.now();

        if (diff <= 0) {
          if (timerId) clearInterval(timerId);
          if (hideOnExpire) {
            el.style.display = 'none';
          } else {
            el.innerHTML = '<span class="oloe-cd-expired">' + expiredText + '</span>';
          }
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        setUnit(dayEls, days);
        setUnit(hourEls, hours);
        setUnit(minEls, minutes);
        setUnit(secEls, seconds);
      }

      tick();
      timerId = setInterval(tick, 1000);
    }

    function oloeInitCountdowns() {
      document.querySelectorAll('.oloe-countdown-timer[data-end]').forEach(oloeStartCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', oloeInitCountdowns);
    } else {
      oloeInitCountdowns();
    }

    // Re-init if the section is re-rendered by the theme editor
    document.addEventListener('shopify:section:load', function (evt) {
      evt.target.querySelectorAll('.oloe-countdown-timer[data-end]').forEach(oloeStartCountdown);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
